<template>
	<v-dialog
		v-model="open"
		max-width="700"
		scrollable="scrollable"
		@click:outside="closeDialog()"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white"
					>{{ date | dateFormatter }}　{{ name }}の出庫情報</v-toolbar-title
				>
				<v-spacer></v-spacer>
				<v-btn icon dark color="white" @click="closeDialog()">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2 scroll" min-height="150px">
				<v-sheet elevation="0" class="mt-4">
					<v-row class="d-flex justify-end">
						<v-btn
							v-if="authorityFlag"
							class="mr-6"
							color="secondary"
							@click="openShippingNewDilalg(name, date, id)"
						>
							出庫する
						</v-btn>
					</v-row>
					<h5 class="text-h6 font-weight-bold color-secondary my-1">出庫先製品情報</h5>

					<div v-if="shippings.length > 0">
						<table
							v-for="shipping in shippings"
							:key="shipping.id"
							width="100%"
							class="show-dialog-table mt-2 mb-4"
						>
							<tbody>
								<tr>
									<th width="30%" class="font-weight-bold">出庫対象製造番号</th>
									<td width="70%" v-if="shipping.order_target">
										{{ shipping.order_target.ordered_product.get_processed_product_number }}
									</td>
									<td width="70%" v-else>対象製品はありません</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">出庫部品数</th>
									<td width="70%" class="no-wrap">
										{{ shipping.planned_quantity }}
										<v-icon
											v-if="authorityFlag"
											class="float-right"
											@click="
												openShippingEditDialog(
													name,
													date,
													id,
													shipping.id,
													shipping.planned_quantity
												)
											"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">出庫日</th>
									<td width="70%">
										{{ shipping.operation_date | dateJaFormatter }}
										<v-icon
											v-if="authorityFlag"
											class="float-right"
											@click="openEditReceivingShippingDate(shipping.id, shipping.operation_date)"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else>出庫情報はありません。</div>
				</v-sheet>
			</v-sheet>
		</v-card>
		<ComponentShippingNewDialog
			ref="new_shipping"
			:component_id="id"
			@reload-show="reloadNewShow"
			:authorityFlag="authorityFlag"
		/>
		<ComponentShippingEditDialog
			ref="edit_shipping"
			:date="date"
			:component_id="id"
			:component="component"
			@reload-show="reloadUpdateShow"
			:authorityFlag="authorityFlag"
		/>
		<ReceivingShippingDateEditDialog
			:dialog.sync="dialog"
			:receivingShippingDate="receiving_shipping_date"
			:receivingShippingId="receiving_shipping_id"
			@reload-show="reloadUpdateShow"
			:dialogTitle="dialogTitle"
		/>
	</v-dialog>
</template>

<script>
import ComponentShippingNewDialog from "./ComponentShippingNewDialog.vue"
import ComponentShippingEditDialog from "./ComponentShippingEditDialog.vue"
import ReceivingShippingDateEditDialog from "./ReceivingShippingDateEditDialog.vue"
import moment from "moment"
import "moment/locale/ja"

export default {
	components: {
		ComponentShippingNewDialog,
		ComponentShippingEditDialog,
		ReceivingShippingDateEditDialog,
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
		dateJaFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
	},
	props: {
		ordered_products: {
			type: Array,
			required: false,
			default: () => [],
		},
		authorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			open: false,
			dialog: false,
			id: "",
			name: "",
			date: "",
			shippings: [],
			shipping: {
				order_type: {
					ordered_product: {
						prodcut_number: "",
					},
				},
			},
			component: {},
			total_planned_quantity: "",
			shipping_planned_quantity: "",
			scrollable: false,
			receiving_shipping_date: "",
			receiving_shipping_id: "",
			dialogTitle: "",
		}
	},

	methods: {
		openDialog(
			component,
			date,
			total_planned_quantity,
			shipping_planned_quantity,
			receiving_shippings
		) {
			this.open = true
			this.component = component
			this.name = component.name
			this.date = date
			this.id = component.id
			this.total_planned_quantity = total_planned_quantity
			this.shipping_planned_quantity = shipping_planned_quantity
			this.setShippings(component, date, receiving_shippings)
			this.$emit("reload", component, date)
		},

		setShippings(component, date, receiving_shippings) {
			this.shippings = receiving_shippings.filter(function (value) {
				return (
					value.operation_date == date &&
					value.target_id == component.id &&
					value.movement_type == "shipping" &&
					value.planned_quantity != 0
				)
			})
		},

		reloadNewShow(receiving_shipping) {
			this.shippings.push(receiving_shipping)
			this.$emit("reload-index", receiving_shipping)
		},

		reloadUpdateShow(update_receiving_shipping, delete_receiving_shipping) {
			if (update_receiving_shipping) {
				this.update(update_receiving_shipping)
			} else {
				this.delete(delete_receiving_shipping)
			}
		},

		update(receiving_shipping) {
			const target_receiving_shipping = this.shippings.find(
				(value) => value.id == receiving_shipping.id
			)
			const index = this.shippings.indexOf(target_receiving_shipping)
			target_receiving_shipping.planned_quantity = receiving_shipping.planned_quantity
			target_receiving_shipping.operation_date = receiving_shipping.operation_date
			this.shippings[index] = target_receiving_shipping
		},

		delete(receiving_shipping) {
			const target_receiving_shipping = this.shippings.find(
				(value) => value.id == receiving_shipping.id
			)
			const index = this.shippings.indexOf(target_receiving_shipping)
			this.shippings.splice(index, 1)
			this.$emit("reload-delete-index", target_receiving_shipping.id)
		},

		closeDialog() {
			this.open = false
		},

		openShippingEditDialog(name, date, id, shipping_id, current_planned_quantity) {
			const total_planned_quantity = this.total_planned_quantity
			const shipping_planned_quantity = this.shipping_planned_quantity

			this.$refs.edit_shipping.openDialog(
				name,
				date,
				id,
				shipping_id,
				total_planned_quantity,
				shipping_planned_quantity,
				current_planned_quantity
			)
		},
		openShippingNewDilalg(name, date, id) {
			let total_planned_quantity = this.total_planned_quantity
			this.$refs.new_shipping.openDialog(name, date, id, total_planned_quantity)
		},
		openEditReceivingShippingDate(shipping_id, operation_date) {
			this.receiving_shipping_id = shipping_id
			this.receiving_shipping_date = operation_date
			this.dialogTitle = "出庫日の編集"
			this.dialog = true
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.add-btn {
	text-align: right;
}
.scroll {
	overflow-y: scroll;
	overflow-x: hidden;
}
</style>
